<template>
  <div>
    <Modal
      v-model="addVisible"
      title="加入购物车"
      okText="确定"
      cancelText="取消"
      centered
      @cancel="handleClose"
      @ok="handleSubmit"
    >
      <div class="main">
        <div class="menuPart">
          <div class="leftImg">
            <img class="coffeeImg" :src="detailData.imgUrl" />
          </div>
          <div class="rightDetail">
            <div class="detailBlock">
              <div class="detailName">{{ detailData.name }}</div>
              <!-- <div class="detailClose" @click="handleClose">X</div> -->
            </div>
            <div class="detailPrice">￥{{ detailData.prize }}</div>
            <!-- <div class="detailSale">月销：{{ detailData.mSales }}</div> -->
            <div class="detailBlock">
              <div class="detailPrice">数量</div>
              <Stepper
                v-if="addVisible"
                v-model="shopValue"
                class="detailStepper"
                @changeShop="changeShopVal"
              />
            </div>
          </div>
        </div>
        <div class="preferencePart" :v-model="preferences" v-if="addVisible">
          <div v-for="(item, index) in detailData.preference" :key="index">
            <PreferenceItem
              :initData="item"
              :currentItem="index"
              @changeButton="changePreferences"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { Modal } from "ant-design-vue";
Vue.use(Modal)
import "ant-design-vue/lib/modal/style/css";
import PreferenceItem from "./components/PreferenceItem.vue";
import Stepper from "./components/Stepper.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    addVisible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => {
        return {
          preference: [],
        };
      },
    },
  },
  components: { Modal, PreferenceItem, Stepper },
  data() {
    return {
      preferences: [],
      shopValue: 1, //添加购物车数量
    };
  },
  methods: {
    // 关闭模态框
    handleClose() {
      this.$emit("closeClick", false);
      this.shopValue = 1;
      this.preferences = [];
    },
    //修改添加购物车数量
    changeShopVal(val) {
      this.shopValue = parseInt(val);
    },
    // 修改偏好
    changePreferences(data) {
      const { val, index } = data;
      this.preferences[index] = val;
    },
    handleSubmit(e) {
      // 打开购物车
      this.$store.commit("toggle_show_shopping_cart", true);
      //添加咖啡购物车数据 判定是否是已有数据
      let finalData = [];
      const currentIndex = this.shopping_coffee_data.findIndex(
        (x) =>
          x.id === this.detailData.id &&
          x.preferences.join() === this.preferences.join()
      );
      if (currentIndex < 0) {
        //  当前存储数据拼接新数据
        const newData = [
          {
            ...this.detailData,
            shopValue: this.shopValue,
            preferences: this.preferences,
          },
        ];
        finalData = (this.shopping_coffee_data || []).concat(newData);
      } else {
        // 更新已有数据的数量值
        finalData = [
          ...this.shopping_coffee_data.slice(0, currentIndex),
          {
            ...this.shopping_coffee_data[currentIndex],
            shopValue:
              this.shopping_coffee_data[currentIndex].shopValue +
                this.shopValue >
              999
                ? 999
                : this.shopping_coffee_data[currentIndex].shopValue +
                  this.shopValue,
          },
          ...this.shopping_coffee_data.slice(currentIndex + 1),
        ];
      }
      this.$store.commit("updataCoffeeShop", finalData);
      this.handleClose();
    },
  },
  watch: {
    detailData() {
      this.preferences = this.detailData.preference.map((x) => x.tagList[0]);
    },
    addVisible() {
      if (this.addVisible) {
        this.preferences = this.detailData.preference.map((x) => x.tagList[0]);
      }
    },
  },
  computed: {
    ...mapGetters({
      shopping_coffee_data: "shopping_coffee_data",
    }),
  },
};
</script>
<style lang="less" scoped>
.main {
  padding: 0;
}

.menuPart {
  display: flex;
}
.rightDetail {
  padding: 0px 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 0;
  width: 100%;
  font-size: 15px;
}
.detailBlock {
  display: flex;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
}
.detailPrice {
  /* height: 1rem;
    line-height: 1rem; */
}
.coffeeImg {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/AddShopModal.vue